import React, { forwardRef, useState } from "react";
import "./styles/styles.css";
import "../../styles/global.css";
import "../../styles/app.css";
import { icons } from "../../constants";
import { useTheme } from "../../utils/ThemeContext";

const AccreditationButton = forwardRef(
  (
    {
      onClick,
      className,
      title,
      type,
      icon,
      disabled,
      backgroundColor,
      dark_icon,
      hover_icon,
      tooltip,
      onMouseEnter,
      onMouseLeave,
      classNameWrapper,
    },
    ref,
  ) => {
    const { theme } = useTheme();
    const [isHovered, setIsHovered] = useState(false);

    console.log("tooltip", tooltip);

    const handleMouseEnter = (e) => {
      setIsHovered(true);
      onMouseEnter?.(e);
    };

    const handleMouseLeave = (e) => {
      setIsHovered(false);
      onMouseLeave?.(e);
    };

    const getIconSrc = () => {
      if (isHovered && hover_icon) return hover_icon;
      return theme === "light" ? icon : dark_icon ? dark_icon : icon;
    };

    return (
      <div className={`${classNameWrapper}`}>
        <div className="accreditation-tooltip-wrapper flex-direction-row justify-center">
          <button
            ref={ref}
            onClick={onClick}
            type="button"
            disabled={disabled}
            style={{ backgroundColor }}
            tabIndex="0"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick?.(e);
              }
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={`flex-direction-row items-center justify-between pointer accreditation-button ${
              type || ""
            } ${className || ""} ${disabled ? "disabled" : ""}`}
          >
            {title && <p className="inria-sans-700 font-12">{title}</p>}
            {icon && (
              <img src={getIconSrc()} alt="icon" width={24} height={24} />
            )}
          </button>

          {tooltip && isHovered && (
            <div className="accreditation-tooltip">{tooltip}</div>
          )}
        </div>
      </div>
    );
  },
);

export default AccreditationButton;
